import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Session expired',
  content: 'Please sign in again to continue.',
  loginBtn: 'Sign in',
});
